import { StateCreator } from 'zustand'
import { SellerSliceState, UserSlice, UserSliceState } from '@/types/store.types'
import { getNextFormValues } from '@/utils/store.utils'

/**
 * Initial values for the customer info form
 */
export const formValuesDefault: FormValuesT = {
  country: 'US',
  firstName: '',
  lastName: '',
  email: '',
  emailConfirm: '',
  zipCode: '',
  phoneNumber: '',
  emailSignup: 'true',
  giftOrder: 'false',
  giftOrderFirstName: '',
  giftOrderLastName: '',
  giftOrderEmail: '',
  giftOrderMessage: '',
}

export const userSliceDefault: UserSlice = {
  userIds: {
    uid: null,
    iid: null,
  },
  formValues: formValuesDefault,
}

export const createUserSlice: StateCreator<UserSliceState & SellerSliceState, [], [], UserSliceState> = (
  set,
  get,
) => ({
  ...userSliceDefault,
  syncFormValuesWithProfile: (profile: LoggedInUserProfile | undefined) => {
    const { formValues, userIsLocal } = get() // Get current state

    const nextFormValues = getNextFormValues({
      formValues,
      loggedInUser: profile,
      isLocal: userIsLocal,
    })

    if (JSON.stringify(nextFormValues) !== JSON.stringify(formValues)) {
      set({ formValues: { ...nextFormValues } })
    }
  },
})
